module.exports = __webpack_public_path__ + "static/media/checked.b0750e37.svg";